import type { Tab } from "../hooks/useTab.js";

const TABS: { id: Tab; label: string; path: string }[] = [
  { id: "overlay", label: "🖼️ 蓋圖工具", path: "/overlay-tool" },
  { id: "odp", label: "📊 ODP Card Builder", path: "/odp-card-builder" },
];

interface TabBarProps {
  activeTab: Tab;
  onTabChange: (tab: Tab) => void;
}

export function TabBar({ activeTab, onTabChange }: TabBarProps) {
  return (
    <nav className="tab-bar">
      {TABS.map((t) => (
        <a
          key={t.id}
          className={`tab-btn ${activeTab === t.id ? "active" : ""}`}
          href={t.path}
          onClick={(e) => {
            e.preventDefault();
            onTabChange(t.id);
          }}
        >
          {t.label}
        </a>
      ))}
    </nav>
  );
}
